module.exports = __webpack_public_path__ + "static/media/VICTORY1.c764be9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY1.mp3
// module id = 301
// module chunks = 1 2 3